const TIME_ZONE = 'Europe/Berlin';
const LOCALE = 'de-DE';

/**
 * Formats a UTC ISO string from the API as German date + time, e.g. "18.01.2026, 10:30".
 *
 * The API always sends UTC (Mongo stores BSON dates as UTC ms; `Date.toJSON()` appends the `Z`),
 * so the server's own timezone never matters. The zone is pinned here rather than left to the
 * browser: otherwise the same record would read differently for a viewer outside Germany.
 */
export const formatDateTimeDE = (iso: string | null | undefined): string => {
  if (!iso) return '–';

  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '–';

  return date.toLocaleString(LOCALE, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: TIME_ZONE
  });
};
